export default "__VITE_PUBLIC_ASSET__57808c4c__"